<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="商品名称" prop="name">
                        <el-input style="width: 232px" v-model="searchForm.name" placeholder="请输入商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品编号" prop="goodsNo">
                        <el-input style="width: 232px" v-model="searchForm.goodsNo" placeholder="请输入商品编号"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品类型" prop="goodsType">
                        <el-select style="width: 232px" v-model="searchForm.goodsType" placeholder="请选择商品类型" filterable
                            clearable>
                            <el-option label="普通商品" value="1"></el-option>
                            <el-option label="礼包商品" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="添加时间" prop="createdTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div style="height:10px"></div>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div style="display:flex">
                    <div class="u-btn" @click="pUp('0')">批量删除</div>
                    <el-button type="primary" @click="options('add')" size="small" icon="el-icon-plus">新增商品</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="submitD">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="提示信息" :visible.sync="isS" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left" v-if="uStatus == 1">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认【启用】该商品，启用后活动界面显示该商品！
                </div>
                <div class="info" style="text-align: left" v-if="uStatus == 2">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认【禁用】该商品，禁用后活动界面隐藏该商品！
                </div>
                <div class="info" style="text-align: left" v-if="uStatus == 3">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    该商品系统【已下架】，不能操作【启用】！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isS = false">取消</div>
                    <div class="info-s" v-if="uStatus != 3" @click="submitA()">确定</div>
                    <div class="info-s" v-else @click="isS = false">确定</div>
                </div>
            </template>
        </el-dialog>

        <el-dialog :title="optionsTitle" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogGoods"
            width="60%">
            <div v-if="isLook">

                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" style="margin-top:20px">
                    <el-form-item>
                        <div style="display:flex">
                            <el-button :type="gType == '1' ? 'primary' : ''" size="small"
                                @click="selectG('1')">普通商品</el-button>
                            <el-button :type="gType == '2' ? 'primary' : ''" size="small"
                                @click="selectG('2')">礼包商品</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="" prop="tagName">
                        <el-input style="width: 232px" v-model="name" placeholder="请输入商品名称/商品编号" clearable></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="商品名称" prop="tagName">
                        <el-input style="width: 232px" v-model="name" placeholder="请输入商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品编号" prop="tagName">
                        <el-input style="width: 232px" v-model="goodsNo" placeholder="请输入商品编号" clearable></el-input>
                    </el-form-item> -->
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData1('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData1('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="goodsList" v-if="gType == '1'" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品信息">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <img :src="scope.row.image" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                                <div style="
                                font-size: 14px;
                                min-height: 56px;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                              ">
                                    <p style="color: #333333">{{ scope.row.name }}</p>
                                    <p style="color: #999999">
                                        商品编号：{{ scope.row.goodsNo }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型" width="200px">
                        <template slot-scope="scope">
                            {{ scope.row.typeLabel }}
                        </template>
                    </el-table-column>
                    <el-table-column label="价格" width="200px">
                        <template slot-scope="scope">
                            {{ scope.row.minPrice }}~{{ scope.row.maxPrice }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot="header">
                            <div style="text-align:center">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <div style="text-align: center;margin-left:10px">
                                <div class="btn-y" v-if="scope.row.selected" @click="handleSelectGoods(scope)">已选取</div>
                                <div class="btn-s" v-else @click="handleSelectGoods(scope)">选取</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="gType == '1'" style="
                        display: flex;
                        justify-content: end;
                        align-items: center;
                        height: 42px;
                      ">
                    <el-pagination background @size-change="onGoodsSizeChange" @current-change="onGoodsCurrentChange"
                        :current-page="goodsPageNo" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
                    </el-pagination>

                </div>
                <el-table :data="goodsList1" v-if="gType == '2'" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品信息">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <img :src="scope.row.images" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                                <div style="
                                font-size: 14px;
                                min-height: 56px;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                              ">
                                    <p style="color: #333333">{{ scope.row.name }}</p>
                                    <p style="color: #999999">
                                        商品编号：{{ scope.row.code }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型" width="200px">
                        <template slot-scope="scope">
                            礼包商品
                        </template>
                    </el-table-column>
                    <el-table-column label="价格" width="200px">
                        <template slot-scope="scope">
                            {{ scope.row.price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot="header">
                            <div style="text-align:center">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <div style="text-align: center;margin-left:10px">
                                <div class="btn-y" v-if="scope.row.selected" @click="handleSelectGoods1(scope)">已选取
                                </div>
                                <div class="btn-s" v-else @click="handleSelectGoods1(scope)">选取</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="gType == '2'" style="
                        display: flex;
                        justify-content: end;
                        align-items: center;
                        height: 42px;
                      ">
                    <el-pagination background @size-change="onGoodsSizeChange1" @current-change="onGoodsCurrentChange1"
                        :current-page="goodsPageNo1" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize1"
                        layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum1">
                    </el-pagination>
                </div>
            </div>
            <!-- 编辑商品 -->
            <div v-if="isEdit">
                <el-table border :data="goodsDetail" :span-method="objectSpanMethod" style="width: 100%; margin-top: 20px"
                    :header-cell-style="{
                        'text-align': 'center',
                        background: '#F8F8F8',
                        color: '#333333',
                    }" :cell-style="{ 'text-align': 'center' }">

                    <el-table-column prop="name" label="商品名称">
                    </el-table-column>
                    <el-table-column prop="goodsSkuName" label="商品规格">
                    </el-table-column>
                    <el-table-column prop="retailPrice" label="价格">
                    </el-table-column>
                    <el-table-column prop="seckillPrice" label="活动初始价">
                        <template slot="header">
                            <div><span style="color:red;margin-right:4px">*</span>活动初始价</div>
                        </template>
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.seckillPrice" size="small" placeholder="请输入活动初始价"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="num" label="商品状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.skuStatus == 1">上架</span>
                            <span v-else>下架</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quota" label="活动价购买次数" width="300px">
                        <template slot-scope="scope">
                            <el-radio v-model="scope.row.quota1" label="0">不限</el-radio>
                            <el-radio v-model="scope.row.quota1" label="-1">自定义</el-radio>
                            <el-input v-if="scope.row.quota1 == -1" v-model="scope.row.quota"
                                oninput="value=value.replace(/^0|[^0-9]/g,'')" size="small"
                                style="width: 100px;"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-form style="margin-top:20px">
                    <el-form-item label="排序" label-width="72px">
                        <div style="display:flex">
                            <el-input style="width: 442px" placeholder="请输入排序" v-model="sort"></el-input>
                            <div style="font-size:12px;color:#c6c9d1;margin-left:10px">数字最小排序最上方</div>
                        </div>

                    </el-form-item>
                </el-form> -->
            </div>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="dialogGoods = false">取消</div>
                <div class="info-s" v-if="isLook" @click="addShop">确定</div>
                <div class="info-s" v-if="isEdit" @click="saveGoods">编辑</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
import number from '@/pages/shopManagement/components/number.vue'
import weight from '@/pages/shopManagement/components/weight.vue'
import freeDelivery from '@/pages/shopManagement/components/freeDelivery.vue'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
        number,
        weight,
        freeDelivery
    },
    data() {
        return {
            name: '',
            goodsNo: '',
            gType: '1',
            goodsL: [
                {
                    name: '测试商品',
                    skuName: '袋/包',
                    price: '45.00',
                    num: 12
                },
                {
                    name: '测试商品',
                    skuName: '袋/包',
                    price: '45.00',
                    num: 12
                },
                {
                    name: '测试商品',
                    skuName: '袋/包',
                    price: '45.00',
                    num: 12
                }
            ],
            isS: false,
            sTitle: '批量停用提示',
            sContent: '启用',
            dialogGoods: false,
            radio: '1',
            optionsTag: '新增标签',
            form: {
                id: '',
                tagImg: '',
                tagName: '',
                status: '',
                sort: ''
            },
            rules: {
                tagName: [
                    { required: true, message: '请输入标签名称', trigger: 'blur' },
                ],
                tagImg: [
                    { required: true, message: '请上传标签图片', trigger: 'change' },
                ],
                sort: [
                    { required: true, message: '请输入排序数字', trigger: 'blur' },
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' },
                ],
            },
            goodsList: [
                {
                    goodsName: '测试商品',
                    goodsNo: '7878798',
                    goodsTypeLabel: '普通商品',
                    status: '1'
                },
                {
                    goodsName: '测试商品',
                    goodsNo: '7878798',
                    goodsTypeLabel: '普通商品',
                    status: '2'
                },
            ],
            dialogTags: false,
            isS: false,
            dataList: {
                list: [
                    { title: '营销管理', path: '', type: '0' },
                    { title: '营销活动', path: '/marketingManagement/flashActivity', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '活动详情', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                tagName: '',
                status: '',
                createdTimeStart: "",
                createdTimeEnd: '',
                pageNo: 1,
                pageSize: 10
            },
            value1: [],
            value2: [],
            brandList: [],
            columns: [
                // {
                //     label: '', prop: 'index', minWidth: '80',
                //     render: (h, scope) => {
                //         return (
                //             <div>
                //                 {scope.$index + 1}
                //             </div >
                //         )
                //     }
                // },
                { type: 'selection', minWidth: '80', fixed: 'left' },
                {
                    label: '排序', prop: 'index', minWidth: '80',
                    render: (h, scope) => {
                        return (
                            <div>
                                {scope.$index + 1}
                            </div >
                        )
                    }
                },
                {
                    label: '商品编号', prop: 'goodsNo', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { }}>{scope.row.goodsNo}</span>
                            </div >
                        )
                    }
                },
                {
                    label: '商品图片', prop: 'goodsCount', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div>
                                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                            </div>
                        )
                    }
                },
                { label: '商品名称', prop: 'name', minWidth: '130' },
                { label: '活动最低价', prop: 'minActivatePrice', minWidth: '100' },
                { label: '活动最高价', prop: 'maxActivatePrice', minWidth: '100' },
                { label: '商品类型', prop: 'goodsTypeLabel', minWidth: '120' },
                { label: '活动销售', prop: 'sales', minWidth: '120' },
                { label: '添加时间', prop: 'createdTime', minWidth: '120' },

                {
                    label: '状态', prop: 'statusLabel', minWidth: '130',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusL == '启用') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusL}</div>
                            </p>
                        } else {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusL}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>
                        )
                    }
                },
                {
                    label: '操作',
                    minWidth: '100',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.options('edit', scope.row.id) }}>编辑</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.updateStatus(scope.row) }}>{scope.row.statusLabel}</span>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.deleteD(scope.row.id) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            page1: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            goodsSearch: {
                tagId: '',
                pageNo: 1,
                pageSize: 10,
            },
            exporting: false,
            sName: '启用',
            isStatus: '',
            tagId: null,
            isD: false,
            isLook: true,
            isEdit: false,
            goodsDetail: [],
            sort: '',
            optionsTitle: '选择商品',
            goodsList: [],//商品数据
            goodsPageNo: 1,//商品表格页数
            goodsPageSize: 5,//商品表格每页显示条数
            goodsTotalNum: 0,//商品表格总条数
            goodsList1: [],//礼包商品数据
            goodsPageNo1: 1,//商品表格页数
            goodsPageSize1: 5,//商品表格每页显示条数
            goodsTotalNum1: 0,//商品表格总条数
            seletedGoods: [],//已选商品列表
            seletedGoods1: [],//已选商品列表
            aId: '',
            uStatus: '1',
            dId: [],
            goodsId: ''
        }
    },
    created() {
        this.getPageList()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addTag') {
            next(vm => {
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getPageList();
            });
        }
    },
    methods: {
        fetchData1(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.name = ''
                this.goodsNo = ''
            }
            this.goodsPageNo = 1
            this.goodsPageNo1 = 1
            this.getGoodsList()
        },
        submitA() {
            let goodsId = []
            goodsId.push(this.goodsId)
            let data = {
                id: this.aId,
                goodsId: goodsId,
                status: this.uStatus
            }
            this.axios.post('/marketActivate/disableGoods', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.getPageList()
                        this.isS = false
                    }
                })
        },
        // 编辑保存
        saveGoods() {
            let skuList
            if (Array.isArray(this.goodsDetail)) {
                // 判断是否为空
                let hasPrice = this.goodsDetail.every(e => e.seckillPrice)
                if (!hasPrice) {
                    this.$message.warning('请填写活动初始价')
                    return
                }
                skuList = this.goodsDetail.map(e => ({
                    goodsId: e.goodsId,
                    goodsSku: e.goodsSku,
                    goodsSkuName: e.goodsSkuName,
                    seckillPrice: e.seckillPrice,
                    retailPrice: e.retailPrice,
                    stock: e.stock,
                    status: 1,
                    skuStatus: 1,
                    seckillStock: 9999,
                    quota: e.quota
                }))
            }
            let data = {
                activateId: this.$route.query.id,
                id: this.editId,
                skuList,
                activateStartTime: '2024-01-01 00:00:00',
                activateEndTime: '2034-01-01 00:00:00',
                sort: this.sort,
            }
            // console.log('>>',data)
            // return false
            this.axios.post('/marketActivateSeckill/addGoods', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('编辑成功')
                        this.dialogGoods = false
                        this.getPageList()
                    }
                })
        },
        updateStatus(row) {
            this.isS = true
            this.aId = row.id
            this.goodsId = row.goodsId
            if (row.showStatus == 1) {
                this.uStatus = 2
            } else if (row.status == 0 && row.showStatus == 2) {
                this.uStatus = 3
            } else {
                this.uStatus = 1
            }
        },
        addShop() {
            let goodsIds = []
            this.seletedGoods.forEach(item => {
                goodsIds.push(item.id)
            })
            let giftIds = []
            this.seletedGoods1.forEach(item => {
                giftIds.push(item.id)
            })
            if (goodsIds.length == 0 && giftIds.length == 0) {
                this.$message.warning('请选择商品')
                return
            }
            let data = {
                id: this.$route.query.id,
                goodsIds: goodsIds,
                giftIds: giftIds,
                status: 1
            }
            this.axios.post('/marketActivate/addGoods', data).then(res => {
                if (res.code === 0) {
                    this.dialogGoods = false
                    this.$message.success('添加成功')
                    this.getPageList()
                }
            })

        },
        onGoodsSizeChange(e) {
            this.goodsPageSize = e;
            this.getGoodsList()
        },
        onGoodsCurrentChange(e) {
            this.goodsPageNo = e;
            this.getGoodsList()
        },
        onGoodsSizeChange1(e) {
            this.goodsPageSize1 = e;
            this.getGoodsList()
        },
        onGoodsCurrentChange1(e) {
            this.goodsPageNo1 = e;
            this.getGoodsList()
        },
        //选择商品
        handleSelectGoods(scope) {
            if (!scope.row.selected) {
                let data = {
                    id: scope.row.id,
                    typeFlag: 3
                }
                this.goodsList[scope.$index].selected = true;
                this.seletedGoods.push(data)
            } else {
                this.goodsList[scope.$index].selected = false;

                let idx = this.seletedGoods.findIndex(item => {
                    return item.id == scope.row.id
                })
                this.seletedGoods.splice(idx, 1)
            }
            console.log(this.seletedGoods)

            this.$forceUpdate()
        },
        //选择商品
        handleSelectGoods1(scope) {
            if (!scope.row.selected) {
                let data = {
                    id: scope.row.id,
                    typeFlag: 4
                }
                this.goodsList1[scope.$index].selected = true;
                this.seletedGoods1.push(data)
            } else {
                this.goodsList1[scope.$index].selected = false;

                let idx = this.seletedGoods1.findIndex(item => {
                    return item.id == scope.row.id
                })
                this.seletedGoods1.splice(idx, 1)
            }
            console.log(this.seletedGoods1)

            this.$forceUpdate()
        },
        selectG(val) {
            this.gType = val
            this.goodsPageNo = 1
            this.getGoodsList()//获取商品数据
        },
        //获取商品数据
        getGoodsList() {
            if (this.gType == 1) {
                let data = {
                    pageNo: this.goodsPageNo,
                    pageSize: this.goodsPageSize,
                    nameOrGoodsNo: this.name,
                    status: 1,
                    activateId: this.$route.query.id
                }
                this.axios.post('/goods/pageList', data).then(res => {
                    if (res.code === 0) {
                        res.data.list.forEach(item => {
                            item.selected = false
                        })
                        this.goodsList = res.data.list;
                        this.seletedGoods.forEach(item => {
                            this.goodsList.forEach(el => {
                                if (item.id == el.id) {
                                    el.selected = true;
                                }
                            })
                        })
                        this.goodsTotalNum = res.data.totalNum
                    } else {
                        console.log('goodsPageList - 失败', type)
                    }
                })
            } else {
                let data = {
                    pageNo: this.goodsPageNo1,
                    pageSize: this.goodsPageSize1,
                    nameOrGoodsNo: this.goodsName,
                    status: 1,
                    activateId: this.$route.query.id
                }
                this.axios.post('/giftPackage/pageList', data).then(res => {
                    if (res.code === 0) {
                        res.data.list.forEach(item => {
                            item.selected = false
                        })
                        this.goodsList1 = res.data.list;
                        this.seletedGoods1.forEach(item => {
                            this.goodsList1.forEach(el => {
                                if (item.id == el.id) {
                                    el.selected = true;
                                }
                            })
                        })
                        this.goodsTotalNum1 = res.data.totalNum
                    } else {
                        console.log('goodsPageList - 失败', type)
                    }
                })
            }

        },
        optionUpStatus() {
            this.isS = true
        },
        //表格合并行和列
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let pos = 0
            let len = this.goodsDetail.length
            for (let i = 0; i < len; i++) {
                const item = this.goodsDetail[i]
                if (i === 0) {
                    item.$rows = 1
                    pos = 0
                }
                if (i !== 0) {
                    if (item.name === this.goodsDetail[i - 1].name) {
                        item.$rows = 0
                        this.goodsDetail[pos].$rows = this.goodsDetail[pos].$rows + 1
                    } else {
                        item.$rows = 1
                        pos = i
                    }
                }
            }
            if (columnIndex === 0) {
                return {
                    rowspan: row.$rows,
                    colspan: row.$rows ? 1 : 0,
                };
            }
        },
        pUp(val) {
            if (this.dId.length == 0) {
                this.$message.warning('请选择商品')
                return
            } else {
                this.isD = true
            }


        },
        optionG() {
            this.dialogGoods = true
        },
        options(type, id) {
            if (type == 'add') {
                this.name = ''
                this.optionsTitle = '选择商品'
                this.seletedGoods = []
                this.seletedGoods1 = []
                this.isLook = true
                this.isEdit = false
                this.goodsPageNo = 1
                this.getGoodsList()//获取商品数据
            } else if (type == 'edit') {
                this.optionsTitle = '活动商品设置'
                this.isLook = false
                this.isEdit = true
                this.getDetail(id)
                this.editId = id
            }
            this.dialogGoods = true
        },
        submitD() {
            let data = {
                id: this.$route.query.id,
                goodsId: this.dId,
                isDelete: 1,
            }
            this.axios.post('/marketActivate/deleteGoods', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('删除成功')
                        this.getPageList()
                        this.isD = false
                    }
                })
        },
        deleteD(id) {
            this.isD = true
            this.dId.push(id)
            // let msg = '是否确认删除该商品？'
            // this.$confirm(msg, '温馨信息', {
            //     title: '温馨信息',
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.axios.post('/tags/deleteTagGood', { id: id })
            //         .then(res => {
            //             console.log(res)
            //             if (res.code == 0) {
            //                 this.$message.success('删除成功')
            //                 this.getShopList()
            //                 this.getPageList()
            //             }
            //         })
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消'
            //     })
            // })
        },
        add(val) {
            this.$router.push({
                name: 'addTag',
                query: {
                    id: val
                }
            })
        },
        getShopList() {
            this.goodsSearch.pageNo = this.page1.pageNo
            this.goodsSearch.pageSize = this.page1.pageSize
            this.axios.post('/tags/getGoodsPageByTag', this.goodsSearch)
                .then(res => {
                    console.log(res)
                    this.goodsList = res.data.list;
                    this.page1.totalNum = res.data.totalNum;

                })
        },
        look(id) {
            this.dialogGoods = true
            this.goodsSearch.tagId = id
            this.getShopList()
        },
        isStart(val) {
            this.isS = true
            this.sName = val.statusL
            this.tagId = val.id
            if (val.statusL == '启用') {
                this.isStatus = true
            } else {
                this.isStatus = false
            }

        },
        upStatus() {
            let data = {
                id: this.tagId,
                status: this.isStatus,
            }
            this.axios.post('/tags/updateStatus', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.isS = false
                        this.getPageList()
                    }

                })
        },
        exportFn() {
            this.exporting = true
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.joinTimeStart = this.value1[0];
                this.searchForm.joinTimeEnd = this.value1[1];
            } else {
                this.searchForm.joinTimeStart = ''
                this.searchForm.joinTimeEnd = ''
            }
            if (this.value2) {
                this.searchForm.lastActiveTimeStart = this.value2[0];
                this.searchForm.lastActiveTimeEnd = this.value2[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.axios.post('/users/exportList', this.searchForm)
                .then(res => {
                    console.log(res)
                    this.exporting = false;
                    if (res.code === 0) {
                        this.downloadlink(res.data)
                    }
                })
        },
        // 获取商品详情
        getDetail(id) {
            let data = { id }
            this.goodsDetail = []
            this.sort = ''
            this.axios.post('/marketActivateSeckill/detail', data).then(res => {
                if (res.code == 0) {
                    if (Array.isArray(res.data.skuList)) {
                        res.data.skuList.forEach(item => {
                            item.name = res.data.name
                            item.quota = String(item.quota)
                            item.quota1 = ''
                            if (item.quota != 0) {
                                item.quota1 = '-1'
                            } else {
                                item.quota1 = '0'
                            }
                        })
                    }
                    this.goodsDetail = res.data.skuList
                    this.sort = res.data.sort
                }
            })
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createdTimeStart = this.value1[0];
                this.searchForm.createdTimeEnd = this.value1[1];
            } else {
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            this.getPageList()
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createdTimeStart = this.value1[0];
                this.searchForm.createdTimeEnd = this.value1[1];
            } else {
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.searchForm.id = this.$route.query.id
            this.axios.post('/marketActivate/goodsPageList', this.searchForm)
                .then(res => {
                    console.log(res)
                    res.data.list.forEach(item => {
                        item.mainImageArr = []
                        item.mainImageArr.push(item.image)
                        if (item.showStatus == 1) {
                            item.statusLabel = '禁用'
                            item.statusL = '启用'
                        } else {
                            item.statusLabel = '启用'
                            item.statusL = '禁用'
                        }
                    })
                    this.list = res.data.list;
                    this.page.totalNum = res.data.totalNum;
                })
        },
        onMultipleSelection(e) {
            this.dId = []
            e.forEach(item => {
                this.dId.push(item.id)
            })
        },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        handleSizeChange1(e) {
            this.page1.pageSize = e;
            this.page1.pageNo = 1;
            this.getShopList()
        },
        handleCurrentChange1(e) {
            this.page1.pageNo = e;
            this.getShopList()
        },
        todetail(row) {
            this.$router.push({
                name: 'userDetail',
                query: {
                    id: row.id
                }
            })
        }
    }
}
</script>
  
<style scoped lang="scss">
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #2d46ee;
    background-color: #fff !important;
    border-color: #2d46ee;
    box-shadow: -1px 0 0 0 #2d46ee;
}

.start {
    width: 10px;
    height: 10px;
    background: #13ce4b;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

.end {
    width: 10px;
    height: 10px;
    background: #f63c56;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #303033;
    opacity: 1;
    text-align: center;
}

.btn-y {
    width: 64px;
    height: 32px;
    background: #2D46EE;
    opacity: 1;
    border-radius: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
}

.btn-s {
    width: 64px;
    height: 32px;
    background: #E9ECFE;
    opacity: 1;
    border-radius: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #2D46EE;
    text-align: center;
    cursor: pointer;
}

.u-btn {
    width: 92px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #2D46EE;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #2D46EE;
    text-align: center;
    cursor: pointer;
    margin-right: 18px;
}

/deep/ .el-dialog {
    // display: flex;
    // flex-direction: column;
    // margin: 0 !important;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // max-height: calc(100% - 30px);
    // max-width: calc(100% - 30px);

    .el-dialog__body {
        padding: 30px 25px;
        padding-top: 10px !important;
        // height: 800px;
        flex: 1;
        overflow: auto;
    }
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 37px;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  